export default "__VITE_ASSET__DI7k8Flz__"